import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

// Section 1
// gsap.to('.double-parallax--top .double-parallax__background', {
// 	y: 100, // déplace le fond vers le haut
// 	ease: 'power1.out',
// 	scrollTrigger: {
// 		trigger: '.double-parallax--top',
// 		start: 'top bottom',
// 		end: 'bottom top',
// 		scrub: 0.5
// 	}
// });

// Section 2
// gsap.to('.double-parallax--bottom .double-parallax__background', {
// 	y: -100,
// 	ease: 'power1.out',
// 	scrollTrigger: {
// 		trigger: '.double-parallax--bottom',
// 		start: 'top bottom',
// 		end: 'bottom top',
// 		scrub: 0.5
// 	}
// });
